module.exports = __webpack_public_path__ + "img/functional2-img5.1f4e379b.png";